/* ============
 * Product Transformer
 * ============
 *
 * The transformer for the product.
 */

import Transformer from './transformer';
import moment from 'moment';

export default class BatchTransformer extends Transformer {

  static fetch(batch) {
    return {
      id: batch.id,
      recipeId: batch.recipe_id,
      recipe: batch.recipe,
      ingrediences: batch.ingrediences,
      name: batch.name,
      code: batch.code,
      status: batch.status,
      priorityNumber: batch.priority_number,
      batchNumber: batch.batch_number,
      startDate: batch.start_date,
      endDate: batch.end_date,
      bestBeforeDate: batch.best_before_date,
      expirationDate: batch.expiration_date,
      notes: batch.notes,
      isActive: batch.is_active,
      ingredienceDeductionType: batch.ingredience_deduction_type,
      custom: batch.custom,
      plannedStartingDate: batch.planned_starting_date,
    };
  }

  static send(batch) {
    return {
      id: batch.id,
      recipe_id: batch.recipeId,
      status: batch.status,
      priority_number: batch.priorityNumber,
      batch_number: batch.batchNumber,
      start_date: batch.startDate ? moment(batch.startDate).format('YYYY-MM-DD') : null,
      end_date: batch.endDate ? moment(batch.endDate).format('YYYY-MM-DD') : null,
      best_before_date: batch.bestBeforeDate ? moment(batch.bestBeforeDate).format('YYYY-MM-DD') : null,
      expiration_date: batch.expirationDate ? moment(batch.expirationDate).format('YYYY-MM-DD') : null,
      notes: batch.notes,
      is_active: batch.isActive,
      custom: batch.custom,
      product_id: batch.productId,
      warehouse_id: batch.warehouseId,
      planned_starting_date: batch.plannedStartingDate ? moment(batch.plannedStartingDate).format('YYYY-MM-DD') : null,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/batch.js